// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"29":"90c11289","86":"9c0aa1d0","228":"8a4755e1","329":"a7016638","453":"4ea7954b","700":"93c779d6"}[chunkId] + ".chunk.js";
};